module.exports = __webpack_public_path__ + "img/burger.5e7ddd23.svg";